import get from 'lodash/get';

import { mapGetters } from 'vuex';

export default {
    name: 'GlobalPermissionsProvider',
    props: {
        fetchMethod: {
            type: Function,
            required: true
        }
    },

    data() {
        return {
            permissions: {}
        };
    },

    provide() {
        return {
            checkPermission: this.checkPermission
        };
    },

    computed: {
        ...mapGetters('workspaces', ['workspaceCustomerId']),
        ...mapGetters(['loggedIn'])
    },

    watch: {
        loggedIn(loggedIn) {
            if (loggedIn) {
                this.fetchPermissions();
            } else {
                this.permissions = {};
            }
        }
    },

    async created() {
        const { meta = {} } = this.$route;

        if (!meta.guest) {
            this.fetchPermissions();
        }
    },

    methods: {
        checkPermission(permissionPath) {
            return get(this.permissions, permissionPath, false);
        },
        async fetchPermissions(params = {}) {
            try {
                this.permissions = await this.fetchMethod(params);
            } catch (e) {
                console.log(e);
            }
        }
    },

    render() {
        return this.$slots.default({});
    }
};
